module.exports = __webpack_public_path__ + "img/location-shoreditch.3c68137d.svg";